module.exports = __webpack_public_path__ + "img/desc.3ad29ad6.png";